import React from 'react';
import { useStore } from '../../store';
import { resolveEffectiveLogo, DEFAULT_BRAND_LOGO_URL } from '../../lib/resolveEffectiveLogo';
import { toRelativeLogoMediaUrl } from '../../lib/logoStorageUrl';
import { CoBrandLockup } from '../auth/CoBrandLockup';

export function PortfolioCard({ compact = false }: { compact?: boolean } = {}) {
  const orgLogoUrl = useStore((s) => s.orgLogoUrl);
  const userLogoUrl = useStore((s) => s.userLogoUrl);
  const companyName = useStore((s) => s.companyName);

  const logoUrl = React.useMemo(
    () => resolveEffectiveLogo({ userLogoUrl, orgLogoUrl }),
    [userLogoUrl, orgLogoUrl]
  );

  // First-party brand: the platform company. Accept the post-rebrand name
  // ('datacrate') as well as the legacy 'deep atomic' so the org-logo branch is
  // suppressed for the root company (it IS the platform brand → show the default).
  const isDatacrate = ['datacrate', 'deep atomic'].includes(companyName?.toLowerCase().trim() ?? '');
  const hasCustomLogo = !isDatacrate && logoUrl !== DEFAULT_BRAND_LOGO_URL;

  // Customer-first "hero + powered-by micro-line" (see CoBrandLockup). The
  // customer mark leads as the hero; Datacrate becomes the quiet endorsement.
  return (
    <CoBrandLockup
      variant={compact ? 'nav' : 'card'}
      customerLogoUrl={hasCustomLogo ? toRelativeLogoMediaUrl(logoUrl) : null}
      customerName={companyName}
      className="w-full"
    />
  );
}
